import React, { useState } from 'react'
import './File.css'
import { App, Button, Col, Row, Upload, UploadProps } from 'antd'
import Dragger from 'antd/es/upload/Dragger'
import { FileZipOutlined } from '@ant-design/icons';
import useSearchInvoiceService from '../../../../helper/services/searchInvoiceServices';
const acceptType = "application/x-zip-compressed"
const TWO_MB = 2097152
const File: React.FC = () => {
    const app = App.useApp();
    const [file, setFile] = useState<any | null>(null);
    const searchService = useSearchInvoiceService();
    const props: UploadProps = {
        multiple: false,
        onChange(info) {
            console.log(info);
            if (info.fileList.length === 0) {
                setFile(null);
                return;
            }
            setFile(info.file)
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
        beforeUpload(file, FileList) {
            const isValidType = file.type === acceptType;
            if (!isValidType) {
                app.message.error('File không đúng định dạng. Vui lòng chỉ chọn tệp .zip');
                return Upload.LIST_IGNORE;
            }
            const isValidSize = file.size < TWO_MB
            if (!isValidSize) {
                app.message.error('Vui lòng chọn file nhỏ hơn 2MB');
                return Upload.LIST_IGNORE;
            }
            return false;
        },
    };
    const onSearchClick = () => {
        if (!file) {
            app.message.error("Vui lòng chọn file cần tra cứu");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        searchService
            .getInvoiceByFile(formData)
            .then((response) => {
                window.open(response ?? undefined);
            })
    }
    return (
        <Row className="search-file-form-main">
            <Col xs={0} md={6}></Col>
            <Col xs={24} md={12} className="search-file-form">
                <h1>Tra cứu hóa đơn theo file</h1>
                <Dragger
                    {...props}
                    name='file'
                    multiple={false}
                    maxCount={1}
                    accept={acceptType}>
                    <p className="ant-upload-drag-icon">
                        <FileZipOutlined />
                    </p>
                    <p className="ant-upload-text">Nhấp chuột hoặc kéo thả tập tin hóa đơn vào đây để tải lên</p>
                    <p className="ant-upload-hint">
                        Chỉ chọn một tập tin có phần mở rộng .zip với dung lượng tối đa 2MB
                    </p>
                </Dragger>
                <Button type='primary' onClick={onSearchClick}>Tra cứu</Button>
            </Col>
            <Col xs={0} md={6}></Col>

        </Row >
    )
}
export default File;